import React, { useEffect, useState } from 'react';
import { Input, Label } from 'reactstrap';
import filterXSS from 'xss';

import { fixDecimal } from 'App/app/cart-logic';
import { currency, subscriptionPlans } from 'App/config';

import './savings-calculator.scss';

const commissionPercents = [3, 3.5, 4, 4.5, 5, 6, 7, 8];
const orderAmountOptions = [100, 150, 200, 250, 300, 400, 500, 1000];
const orderAvgPrices = [35, 40, 45, 50, 60, 70, 80, 90, 100];

const SubsciptionSavingsCalculator = ({ className = '' }) => {
  const [values, setValues] = useState({
    commissionPercent: 5,
    ordersMonthlyAmount: 200,
    avgOrderValue: 65,
  });
  useEffect(() => {
    const urlParams = new URLSearchParams(filterXSS(window.location.search));
    const valuesToUpdate = {};
    if (urlParams.has('commission')) {
      valuesToUpdate.commissionPercent = urlParams.get('commission');
    }
    if (urlParams.has('ordersAmount')) {
      valuesToUpdate.ordersMonthlyAmount = urlParams.get('ordersAmount');
    }
    if (urlParams.has('orderAvg')) {
      valuesToUpdate.avgOrderValue = urlParams.get('orderAvg');
    }
    if (Object.keys(valuesToUpdate).length > 0) {
      setValues({ ...values, ...valuesToUpdate });
    }
  }, []);

  const handleChange = e => {
    const value = e.target.value;
    const parsedValue = value ? parseFloat(value, 10) : '';
    setValues({
      ...values,
      [e.target.name]: parsedValue,
    });
  };
  const {
    currentCommission,
    price,
    restaurantSavings,
  } = calculateSavingsWithSubscription(values);
  const isAnyNan = isNaN(currentCommission) || isNaN(price) || isNaN(restaurantSavings);
  return (
    <div className={`savings-calculator ${className}`}>
      <h2 className="h3 mb-1 pl-0">Zobacz ile możesz zaoszczędzić</h2>
      <h4>zmieniając zamówienia z prowizją na nasz abonament</h4>
      <div className="row mx-0 mt-3 justify-content-between w-100">
        <div className="calculator-variable col">
          <Label name="commissionPercent">Obecna prowizja</Label>
          <Input name="commissionPercent" value={values.commissionPercent} onChange={handleChange} type="select">
            {commissionPercents.map(p => <option key={p} value={p}>{p}%</option>)}
          </Input>
        </div>
        <div className="calculator-variable col">
          <Label name="ordersMonthlyAmount">Liczba zamówień</Label>
          <Input name="ordersMonthlyAmount" value={values.ordersMonthlyAmount} onChange={handleChange} type="select" >
            {orderAmountOptions.map(p => <option key={p} value={p}>{p} zamówień w miesiącu</option>)}
          </Input>
        </div>
        <div className="calculator-variable col">
          <Label name="avgOrderValue">Wartość zamówienia</Label>
          <Input name="avgOrderValue" value={values.avgOrderValue} onChange={handleChange} type="select">
            {orderAvgPrices.map(p => <option key={p} value={p}>{p} zł</option>)}
          </Input>
        </div>
        <div className="col mt-3 mt-md-0 col-xs-12 col-md-auto calculator-savings">
          <div className="col p-0">
            <h5 className="savings-item__title">Miesięczny koszt</h5>
            <div className="row flex-nowrap justify-content-center">
              <div className="text-danger savings-item__number savings-item__number--crossed">{isAnyNan ? '-' : currentCommission} {currency}</div>
              <span className="savings-item__number mx-1">-&gt;</span>
              <div className="text-success savings-item__number">{isAnyNan ? '-' : price} {currency}</div>
            </div>
          </div>
          <div className="col">
            <h5 className="savings-item__title">Zaoszczędzasz</h5>
            <div className="savings-item__number savings-item__number--main">{isAnyNan ? '-' : restaurantSavings} {currency}</div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default SubsciptionSavingsCalculator;

export function calculateSavingsWithSubscription(input) {
  const { commissionPercent, ordersMonthlyAmount, avgOrderValue } = input;
  const lowestPlanThatFits = subscriptionPlans
    .filter(plan => plan.ordersAmount >= ordersMonthlyAmount)
    .sort((a, b) => a.price - b.price)[0];
  const currentCommission = fixDecimal(ordersMonthlyAmount * avgOrderValue * commissionPercent / 100);
  const restaurantSavings = fixDecimal(currentCommission - lowestPlanThatFits.price);
  return {
    currentCommission,
    price: lowestPlanThatFits.price,
    restaurantSavings,
  }
}
